<style>

.tabs{
  display: grid;
  grid-template-columns: 50% 50%; /* default */
  font-size: 16px;
}
.tab{
  text-align: center;
  border-right: 1px gray solid;
  padding: 15px 0;
}
.tab:last-child{
  border-right: none;
}
.selected{
  background-color: rgba(255,255,255,0.2);
}

</style>

<div class="tabs" style="grid-template-columns: repeat({items.length}, {spacing}%);">
  {#each items as item}
    <div class="tab {item.selected ? 'selected' : ''}" on:click="{ () => helper(item) }">{item.name}</div>
  {/each}
</div>

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

/* 
{ name: "", callback: "", selected: false }, 
*/
export let items = [];


let spacing = 0;

$:{
  if (items) calc();
}


function calc() {
  spacing = 100 / items.length;
}


function helper(item) {
  dispatch(item.callback);
  dispatch("updated", {text: item.name});
}

</script>